import React from 'react'

class AboutFr extends React.Component {
  render() {
    return <div>
      <h2>À propos de la banque de données</h2>

      <p><strong>La banque de données SenLex </strong><strong>est un recueil d'informations officielles sur la réglementation institutionnelle belge.&nbsp;&nbsp; Vous y trouverez, pour chaque article des principales normes institutionnelles, les extraits pertinents des documents parlementaires, de la jurisprudence de la Cour constitutionnelle et des avis du Conseil d'État.&nbsp; </strong></p>

      <p>La réglementation institutionnelle belge comprend <strong>la Constitution, les lois à majorité spéciale et plusieurs lois ordinaires</strong>.&nbsp;</p>

      <p>Il est rare cependant que le texte légal suffise à lui seul pour éclairer la portée exacte de la réglementation visée. Le contenu des textes de loi institutionnels est largement déterminé par les travaux parlementaires préparatoires y afférents, les arrêts de la Cour constitutionnelle et les avis et arrêts du Conseil d'État.&nbsp;&nbsp; Les informations officielles sur la réglementation institutionnelle belge sont particulièrement nombreuses, mais elles sont très dispersées et manquent souvent de clarté.&nbsp;&nbsp; SenLex regroupe ces informations officielles issues <strong>des travaux parlementaires préparatoires, des arrêts de la Cour constitutionnelle ainsi que des avis et arrêts du Conseil d'État</strong>.&nbsp;</p>

      <p>Les données sont structurées par article ou, si nécessaire, par partie d'article. Pour chaque article, les informations sont réparties dans les rubriques suivantes:</p>

      <ul>
        <li>texte légal</li>
        <li>mots-clés</li>
        <li>annotations:
          <ul>
            <li>historique du texte légal</li>
            <li>travaux parlementaires préparatoires</li>
            <li>jurisprudence et avis</li>
            <li>commentaire</li>
            <li>renvois à d'autres articles.</li>
          </ul>
        </li>
      </ul>

      <p>Les rubriques "travaux parlementaires préparatoires" et "jurisprudence et avis" comprennent non seulement des <strong><em>hyperliens</em></strong> renvoyant aux documents visés mais reproduisent aussi les extraits pertinents de ces documents <strong>dans leur intégralité</strong>.&nbsp; Il n'est donc pas nécessaire que vous cherchiez vous-même dans les documents les parties de texte se rapportant à l'article concerné; SenLex vous fournira elle-même ces extraits <em>in extenso</em>.</p>

      <p>Via la <a href="/fr">page d'accueil</a>, vous pouvez soit accéder directement aux différents textes annotés, soit effectuer des recherches à l'aide de la fonction de recherche, au moyen de mots-clés ou de termes de votre choix.</p>

      <p>SenLex collecte les informations officielles publiées <strong>depuis le 1er juillet 2014</strong>. Toutefois, elle renferme aussi l'intégralité des travaux parlementaires préparatoires de la sixième réforme de l'État, déjà publiés avant cette date. Des textes plus anciens peuvent également être consultés dans certains cas exceptionnels.&nbsp;&nbsp;</p>

      <p>La banque de données SenLex est développée par les services du Sénat. Elle a une valeur purement informative. Elle est élaborée avec le plus grand soin, mais ni le Sénat ni les services ne peuvent être tenus responsables de son contenu. Vous trouverez plus d'informations à ce sujet dans <a href="/fr/disclaimer">l'avis relatif à la clause de non-responsabilité</a>.</p>
    </div>
  }
}



export default AboutFr;



/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/about/fr.js
 **/